module.exports = __webpack_public_path__ + "media/images/favicon-9c2c4f8c607dec3ff43ab257221a57c6.ico";